import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    HStack,
    Box,
    Text,
    Spacer,
    Stack,

} from '@chakra-ui/react'
import SraList from './SraList'
import moment from 'moment/moment'


export default function TrackSraDetails({ isOpen, onClose, singleData }) {


    console.log("singleDAta", singleData)
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Track SRA Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"20px"}>
                    <HStack>
                            <SraList title={"Product Name: "} details={singleData[0]?.shelfid.productname} />
                            <Spacer />
                            <SraList title={"Product Shelf ID: "} details={singleData[0]?.shelfid.productshelfid} />
                        </HStack>
                        <HStack>
                            <SraList title={"Quantity Inspected: "} details={singleData[0]?.qtyinspected} />
                            <Spacer />
                            <SraList title={"Quantity Certified: "} details={singleData[0]?.qtycertified} />
                        </HStack>
                        <HStack>
                            <SraList title={"Price: "} details={singleData[0]?.price !==null ? singleData[0]?.price: "Awaiting account approval"} />
                            <Spacer />
                            <SraList title={"date received: "} details={moment(singleData[0]?.sra?.datereceived).format('DD/MM/YYYY')} />
                        </HStack>
                        <HStack>
                            <SraList title={"invoice number: "} details={singleData[0]?.sra?.invoicenumber} />
                            <Spacer />
                            <SraList title={"value: "} details={singleData[0]?.value} />
                        </HStack>
                       
                      
                        <SraList title={"Received by:"} details={singleData[0]?.sra?.received} />

                    




                    </Stack>

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
